import {
  GET_OTS,
  GET_BXP_OTS_BY_ID,
  GET_BXP_OTS_MINE,
  GET_FILTERD_OTS,
  GET_MINE_BXP_ORDER,
  GET_BXP_ORDER,
  GET_BXP_THOGETHER2,
  GET_BXP_THOGETHER3,
  GET_BXP_THOGETHER4,
  GET_BXP_THOGETHER5,
  GET_BXP_THOGETHER1,
  GET_MINE_ACTIVE_BXP_LIST,
  GET_OTS_BY_ID,
  GET_OTS_REQUEST_BY_ID,
} from "../constants/index";

export const ots = (
  state = {
    getotslist: [],
    getotsbyid: {},
    getfilterdots: {},
    minebxporderlist: {},
    bxporderlist: {},
    bxptogetherlist1: {},
    bxptogetherlist2: {},
    bxptogetherlist3: {},
    bxptogetherlist4: {},
    bxptogetherlist5: {},
    mineactivebxplist: {},
  },
  action
) => {
  switch (action.type) {
    case GET_OTS:
      return { ...state, getotslist: action.getotslist };
    case GET_BXP_OTS_MINE:
      return { ...state, getmineotslist: action.getmineotslist };
    case GET_BXP_OTS_BY_ID:
      return { ...state, getotsbyid: action.getotsbyid };
    case GET_FILTERD_OTS:
      return { ...state, getfilterdots: action.getfilterdots };
    case GET_MINE_BXP_ORDER:
      return { ...state, minebxporderlist: action.minebxporderlist };
    case GET_BXP_ORDER:
      return { ...state, bxporderlist: action.bxporderlist };
    case GET_BXP_THOGETHER1:
      return { ...state, bxptogetherlist1: action.bxptogetherlist1 };
    case GET_BXP_THOGETHER2:
      return { ...state, bxptogetherlist2: action.bxptogetherlist2 };
    case GET_BXP_THOGETHER3:
      return { ...state, bxptogetherlist3: action.bxptogetherlist3 };
    case GET_BXP_THOGETHER4:
      return { ...state, bxptogetherlist4: action.bxptogetherlist4 };
    case GET_BXP_THOGETHER5:
      return { ...state, bxptogetherlist5: action.bxptogetherlist5 };
    case GET_MINE_ACTIVE_BXP_LIST:
      return { ...state, mineactivebxplist: action.mineactivebxplist };
    case GET_OTS_REQUEST_BY_ID:
      return { ...state, otsrequestbyid: action.otsrequestbyid };
    default:
      return state;
  }
};
